export const AppDownloadBannerSectionSM = () => {
  return (
    <section className="w-full flex justify-center mt-8 relative ">

      {/* CARD */}
      <div
        className="
          relative
        
          overflow-hidden
          px-6 pt-10 md:px-[100px] md:py-16

          flex
          flex-col md:flex-row
          items-center
          justify-between
          gap-10 md:gap-0

          bg-gradient-to-br
          from-[#8F0000]
          via-[#D40000]
          to-[#FF0000]
        "
      >

        {/* LEFT SIDE */}
        <div className="max-w-[640px] text-white z-10 text-center md:text-left">

          <h2 className="
            text-[20px] sm:text-4xl md:text-[64px]
            leading-tight md:leading-[72px]
            font-semibold
            mb-4 md:mb-6
          ">
            Ready to Experience More?
          </h2>

          <p className="
            text-[12px] sm:text-base md:text-[20px]
            text-white/90
            leading-relaxed md:leading-[34px]
            mb-8 md:mb-10
          ">
            Join the community of Canadians discovering better deals, earning real rewards, and supporting the local businesses that make their city great.
          </p>

          {/* STORE BUTTONS */}
          <div className="flex flex-col min-[768px]:flex-row sm:flex-row gap-4 md:gap-5 items-center md:items-center">

            {/* APP STORE */}
            <a
              href="https://couponbook.app.link/BsnZ5PEfH2b"
              target="_blank"
              className="
                w-full  min-[768px]:w-auto
                flex justify-center items-center
                bg-black
                px-6 py-3
                rounded-full
                hover:opacity-90
                transition
              " rel="noreferrer"
            >
              <img
                src="/images/AppleLogo.png"
                className="h-6 md:h-7"
                alt="App Store"
              />
            </a>

            {/* GOOGLE PLAY */}
            <a
              href="https://couponbook.app.link/BsnZ5PEfH2b"
              target="_blank"
              className="
                w-full  min-[768px]:w-auto
                flex justify-center items-center
                bg-black
                px-6 py-3
                rounded-full
                hover:opacity-90
                transition
              " rel="noreferrer"
            >
              <img
                src="/images/rectangle-34625679.png"
                className="h-6 md:h-7"
                alt="Google Play"
              />
            </a>

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="relative flex items-center justify-center w-full ">

          {/* glow */}
          <div
            className="
              absolute
              bottom-[-80px] md:bottom-[-120px]
              w-[clamp(600px, 80vw, 800px)] h-[clamp(600px, 80vw, 800px)] ]
              bg-black/25
              blur-[120px] md:blur-[200px]
              rounded-full
            "
          />

          {/* PHONE */}
          <img
  src="/images/group-2085663667.svg"
  alt="App preview"
  className="relative max-w-[420px] object-contain "
  style={{ width: "clamp(380px, 25vw, 280px)" }}
/>

        </div>

      </div>
    </section>
    
  );
};